import React, {useEffect} from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import UserService from '../../../../api/gerep/UserService'
import LocalStorage from '../../../../business/storage/LocalStorage'
import GerepAPI from '../../../../api/gerep/GerepAPI'

declare global {
	interface Window {
		__AUTH_CODE_REDIRECT_URIS__: any,
	}
}

/**
 * Les redirect_uri autorisées par /loginAuthCode (conf api.security.authCode.redirectUris)
 */
const authCodeRedirectUris: string[] = `${window.__AUTH_CODE_REDIRECT_URIS__ || ''}`
	.split(',')
	.map(uri => uri.trim())
	.filter(uri => uri !== '')

/**
 * La redirect_uri doit être en https et commencer par l'une des redirect_uri autorisées
 */
const isRedirectUriAutorisee = (redirectUri: string | null): boolean => {
	if (!redirectUri) {
		return false
	}
	try {
		if (new URL(redirectUri).protocol !== 'https:') {
			return false
		}
	} catch (e) {
		return false
	}
	return authCodeRedirectUris.some(uri => redirectUri.startsWith(uri))
}

const OauthPage = (
	{

	}
) => {

	const urlParams = new URLSearchParams(window.location.search)
	const redirectUriAutorisee = isRedirectUriAutorisee(urlParams.get('redirect_uri'))

	useEffect(() => {
		// On appel le service de ticket
		if (urlParams != undefined && redirectUriAutorisee) {
			UserService.getAuthCode(LocalStorage.getToken()).then((weakToken) => {
				GerepAPI.post('/loginAuthCode', {token: weakToken, redirectUri: urlParams.get('redirect_uri'), nonce: urlParams.get('nonce')}, LocalStorage.getToken(), true).then((authCode) => {
					window.location.href =  urlParams.get('redirect_uri') + "?state=" +  urlParams.get('state') + "&nonce=" +  urlParams.get('nonce') + "&code=" + authCode.code
				})
			})
		}
	}, [urlParams])


	if (!redirectUriAutorisee) {
		return (
			<>Redirection non autorisée</>
		)
	}

	return (
		<>Will redirect in few seconds...</>
	)
}

const mappedActions = {

}

const mapStateToProps = (state: any) => ({

})

export default compose(
	connect(mapStateToProps, mappedActions))(OauthPage)
